export const LAYER_TRANSLATIONS = {
  //basemap
  baseMap: {
    de: 'Basiskarten',
    en: 'Base map',
    fr: 'Carte de base',
  },
  local: {
    de: 'Lokal',
    en: 'Local',
    fr: 'Local',
  },
  openStreetMap: {
    de: 'OpenStreetMap',
    en: 'OpenStreetMap',
    fr: 'OpenStreetMap',
  },
  geoAdminSwissImage: {
    de: 'SWISSIMAGE',
    en: 'SWISSIMAGE',
    fr: 'SWISSIMAGE',
  },
  geoAdminPixel: {
    de: 'Pixelkarte farbig',
    en: 'Colored pixel map',
    fr: 'Carte pixelisée en couleur',
  },
  geoAdminPixelBW: {
    de: 'Pixelkarte grau',
    en: 'Gray pixel map',
    fr: 'Carte pixelisée en gris',
  },
  geodiensteAV: {
    de: 'geodienste Amtliche Vermessung farbig',
    en: 'geodienste official measurement colored',
    fr: 'geodienste Mensuration officielle en couleur',
  },
  geodiensteAVSituation: {
    de: 'geodienste Amtliche Vermessung Situationsplan',
    en: 'geodienste official measurement situation map',
    fr: 'geodienste Mensuration officielle Plan de situation',
  },
  noBaseMap: {
    de: 'keine Basiskarte',
    en: 'no base Map',
    fr: 'pas de carte de base',
  },

  //drawLayer
  drawLayer: {
    de: 'Zeichnungsebene',
    en: 'Drawing layer',
    fr: 'Couche de dessin',
  },
  addDrawLayer: {
    de: 'Zeichnungsebene hinzufügen',
    en: 'Add drawing layer',
    fr: 'Ajouter une couche de dessin',
  },
  fieldRequired: {
    de: 'Bitte füllen Sie dieses Feld aus.',
    en: 'Please fill out this field.',
    fr: 'Veuillez remplir ce champ.',
  },
  nameExists: {
    de: 'Name existiert bereits.',
    en: 'Name already exists.',
    fr: 'Ce nom existe déjà.',
  },
  renameLayer: {
    de: 'Ebene umbenennen',
    en: 'Rename layer',
    fr: 'Renommer la couche',
  },
  deleteLayer: {
    de: 'Ebene löschen',
    en: 'Delete layer',
    fr: 'Supprimer la couche',
  },
  show: {
    de: 'Anzeigen',
    en: 'Show',
    fr: 'Afficher',
  },
  hide: {
    de: 'Ausblenden',
    en: 'Hide',
    fr: 'Masquer',
  },
  deleteLayerConfirm: {
    de: 'Wollen sie diese Ebene wirklich löschen? Alle Elemente werden gelöscht.',
    en: 'Do you really want to delete this layer? All elements will be deleted.',
    fr: 'Voulez-vous vraiment supprimer cette couche ? Tous les éléments seront supprimés.',
  },

  //mapLayers
  layers: {
    de: 'Ebenen',
    en: 'Layers',
    fr: 'Couches cartographiques',
  },
  legendNotLoaded: {
    de: 'Die Legende für diese Karte konnte leider nicht geladen werden',
    en: 'The legend for this map could not be loaded',
    fr: "La légende de cette carte n'a pas pu être chargée",
  },
  addNewLayer: {
    de: 'Neue Ebene erstellen',
    en: 'Create new layer',
    fr: 'Créer un nouveau couche',
  },
  newLayerType: {
    de: 'Wählen sie den Ebenentyp',
    en: 'Choose layer type',
    fr: 'Choisissez le type de calque',
  },
  layerSource: {
    de: 'Ebenen Quelle',
    en: 'Layer Source',
    fr: 'Source du couche',
  },
  layerSourceUrl: {
    de: 'Quell-URL',
    en: 'source URL',
    fr: 'URL source',
  },
  geodiensteLayerId: {
    de: 'Geodienste Ebenen Id',
    en: 'Geodienste layer id',
    fr: 'Id de couche geodienste',
  },
  mapLayerType: {
    de: 'Ebenentyp',
    en: 'Layer type',
    fr: 'Type de calque',
  },
  persistLayers: {
    de: 'Ebenen auf Ereignis speichern',
    en: 'Save layers to event',
    fr: "Enregistrer les couches dans l'événement",
  },
  toastPersistLayers: {
    de: 'Ebenen auf Ereignis gespeichert',
    en: 'Layers saved on event',
    fr: 'Couches enregistrées sur événement',
  },

  //favorites
  favoriteLayers: {
    de: 'Favoriten',
    en: 'Favorites',
    fr: 'Favoris',
  },
  noMoreFavorites: {
    de: 'Keine Favoriten mehr vorhanden',
    en: 'No more favorites available',
    fr: 'Pas de favoris',
  },

  //availLayers
  availableLayers: {
    de: 'Verfügbare Ebenen',
    en: 'Available layers',
    fr: 'Couches cartographiques disponibles',
  },
  allSources: {
    de: 'Alle Quellen',
    en: 'all sources',
    fr: 'toutes les sources',
  },
  ownMapLayers: {
    de: 'Eigene Ebenen',
    en: 'Own layers',
    fr: 'Couche propres',
  },
  ownMapLayersTitleSuffix: {
    de: 'eigen',
    en: 'own',
    fr: 'propre',
  },
  globalMapLayers: {
    de: 'Geteilte Ebenen',
    en: 'Shared layers',
    fr: 'Couche partagées',
  },
  globalMapLayerTitleSuffix: {
    de: 'geteilt',
    en: 'shared',
    fr: 'partagée',
  },
  managedMapLayers: {
    de: 'ZSKarte verwaltete Ebenen',
    en: 'ZSKarte managed layers',
    fr: 'Couches gérées par ZSKarte',
  },
  managedMapLayerTitleSuffix: {
    de: 'verwaltet',
    en: 'managed',
    fr: 'géré',
  },
  searchableLayer: {
    de: 'offline durchsuchbar',
    en: 'offline searchable',
    fr: 'recherche hors ligne',
  },

  //WMS sources
  editWmsSources: {
    de: 'WMS/WMTS Quellen Bearbeiten',
    en: 'Edit WMS/WMTS Sources',
    fr: 'Modifier les sources WMS/WMTS',
  },
  addLayerSource: {
    de: 'Neue Quelle Hinzufügen',
    en: 'Add new source',
    fr: 'Ajouter une nouvelle source',
  },
  selectLayerSource: {
    de: 'Quelle auswählen',
    en: 'select source',
    fr: 'sélectionner la source',
  },
  removeSource: {
    de: 'entfernen',
    en: 'remove',
    fr: 'supprimer',
  },
  addSource: {
    de: 'Hinzufügen',
    en: 'Add',
    fr: 'Ajouter',
  },

  //general setting fields
  publicSource: {
    de: 'Öffentliche Quelle',
    en: 'public source',
    fr: 'source publique',
  },
  publicSourceInfo: {
    de: 'Quelle darf von anderen Organisationen verwendet werden.',
    en: 'Source may be used by other organizations.',
    fr: "La source peut être utilisée par d'autres organisations.",
  },
  sourceAttribution: {
    de: 'Quellenangabe',
    en: 'source attribution',
    fr: 'attribution de la source',
  },
  sourceAttributionInfo: {
    de: 'Hier gepflegte Quellenangaben überschreiben die Angaben aus der Ebenen Quelle.',
    en: 'Source attribution maintained here overwrites the information from the layer source.',
    fr: 'Les attribution de la source conservées ici écrasent les informations de la source du couche.',
  },

  //WMS layer
  wmsLayerSettings: {
    de: 'Einstellungen der WMS-Ebene',
    en: 'WMS layer settings',
    fr: 'Paramètres de calque WMS',
  },
  wmsLayerName: {
    de: 'Ebenenname',
    en: 'layer name',
    fr: 'nom du calque',
  },
  wmsLayerRenderType: {
    de: 'Ebenen Generierung',
    en: 'Layer generation',
    fr: 'Génération de calque',
  },
  wmsLayerRenderTypeTiled: {
    de: 'gekachelt',
    en: 'tiled',
    fr: 'carrelé',
  },
  wmsLayerRenderTypeFullImage: {
    de: 'Vollbild',
    en: 'fullimage',
    fr: 'image complète',
  },
  hideSubLayers: {
    de: 'Unterebenen ausblenden',
    en: 'hide sub layers',
    fr: 'masquer les sous-calque',
  },
  wmsLayerDrawingMode: {
    de: 'Ebenen-Zeichenmodus',
    en: 'Layers drawing mode',
    fr: 'Mode de dessin des calques',
  },
  mergedLayers: {
    de: 'zusammengeführte Ebenen',
    en: 'merged layers',
    fr: 'calques fusionnés',
  },
  separatedLevels: {
    de: 'aufgetrennte Ebenen',
    en: 'separated layers',
    fr: 'calques séparés',
  },
  tileFormat: {
    de: 'Inhaltstyp',
    en: 'content type',
    fr: 'type de contenu',
  },
  tileSize: {
    de: 'Kachelgrösse',
    en: 'Tile size',
    fr: 'Dimension des carreaux',
  },
  MinScaleDenominator: {
    de: 'Min. Skalennenner',
    en: 'Min scale denominator',
    fr: "Dénominateur d'échelle minimum",
  },
  MaxScaleDenominator: {
    de: 'Max. Skalennenner',
    en: 'Max scale denominator',
    fr: "Dénominateur d'échelle maximum",
  },

  //GeoJson / Shape / CSV Layers
  geojsonLayerSettings: {
    de: 'Einstellungen der GeoJSON/CSV-Ebene',
    en: 'GeoJSON/CSV layer settings',
    fr: 'Paramètres de calque GeoJSON/CSV',
  },
  mediaSource: {
    de: 'Verwaltete Medienquelle',
    en: 'Managed media source',
    fr: 'Source multimédia gérée',
  },
  mediaSourceInfo: {
    de: 'Die Ebene besitzt eine zentral verwaltete Medienquelle, id:',
    en: 'The layer has a centrally managed media source, id:',
    fr: 'La couche possède une source multimédia gérée de manière centralisée, id:',
  },
  mediaSourceActive: {
    de: 'Die verwaltete Medienquelle verwenden',
    en: 'Use the managed media source',
    fr: 'Utiliser la Source multimédia gérée',
  },
  delimiter: {
    de: 'Trennzeichen',
    en: 'delimiter',
    fr: 'délimiteur',
  },
  fieldX: {
    de: 'Feldname der X-Koordinate',
    en: 'field name of the X coordinate ',
    fr: 'nom du champ de la coordonnée X',
  },
  fieldY: {
    de: 'Feldname der Y-Koordinate',
    en: 'field name of the Y coordinate ',
    fr: 'nom du champ de la coordonnée Y',
  },
  dataProjection: {
    de: 'Konfigurationscode für die Datenprojektion',
    en: 'Data projection configuration code',
    fr: 'Code de configuration de la projection de données',
  },
  filterRegExPattern: {
    de: 'RegEx Muster für Daten Filter',
    en: 'RegEx pattern for data filters',
    fr: 'Modèle RegEx pour les filtres de données',
  },
  filterRegExPatternInfo: {
    de: 'Mehrere Werte als Wertegruppe zulassen, z.B.',
    en: 'Allow multiple values be value group e.g.',
    fr: 'Autoriser plusieurs valeurs à être un groupe de valeurs, par ex.',
  },
  filterRegExPatternInfo2: {
    de: 'Werte durch negatives Lookbehind ausschliessen, z.B.',
    en: 'Exclude values by negative lookbehind e.g.',
    fr: 'Exclure les valeurs par lookbehind négatif, par ex.',
  },
  Field: {
    de: 'Feld',
    en: 'Field',
    fr: 'Champ',
  },
  extent: {
    de: 'Gültiger Bereich',
    en: 'Valid area extent',
    fr: 'Étendue de zone valide',
  },
  limitExtent: {
    de: 'Beschränken Sie die Daten auf einen bestimmten Bereich.',
    en: 'Limit the data to a specific area.',
    fr: 'Limitez les données à une zone spécifique.',
  },
  extentInfo: {
    de: 'Der Bereich muss in Datenprojektion angegeben werden. Wenn kein Bereich definiert ist, wird es auf die Schweiz beschränkt.',
    en: 'The area must be specified in dataProjection. If no area is defined, it will be limited to Switzerland.',
    fr: "La zone doit être spécifiée dans projection de données. Si aucune zone n'est définie, le champ d'application est limité à la Suisse.",
  },
  styleSourceType: {
    de: 'Stilquellentyp',
    en: 'Style source Type',
    fr: 'Type de source de style',
  },
  styleSourceTypeUrl: {
    de: 'URL',
    en: 'URL',
    fr: 'Url',
  },
  styleSourceTypeText: {
    de: 'Text',
    en: 'Text',
    fr: 'Texte',
  },
  styleFormat: {
    de: 'Stilformat',
    en: 'Style format',
    fr: 'Format des styles',
  },
  styleFormatMapBox: {
    de: 'MapBox GL Style',
    en: 'MapBox GL Style',
    fr: 'MapBox GL Style',
  },
  styleFormatOlFlat: {
    de: 'OpenLayers Flat',
    en: 'OpenLayers Flat',
    fr: 'OpenLayers Flat',
  },
  styleFormatSpec: {
    de: 'Spezifikation',
    en: 'Specification',
    fr: 'Spécification',
  },
  styleSourceName: {
    de: 'Name der Stilquelle',
    en: 'Style source name',
    fr: 'Nom de la source du style',
  },
  styleSourceUrl: {
    de: 'Stil URL',
    en: 'Style URL',
    fr: 'URL du style',
  },
  styleSourceText: {
    de: 'Stil Konfig',
    en: 'style config',
    fr: 'Configuration du style',
  },
  layerSearchable: {
    de: 'Ist die Ebene durchsuchbar?',
    en: 'Can the layer be searched?',
    fr: 'La couche est-elle consultable?',
  },
  searchResultLabelMask: {
    de: 'Suchergebnis Beschriftungs-Maske',
    en: 'Search result label mask',
    fr: "Masque d'étiquette de résultat de recherche",
  },
  searchResultLabelMaskInfo: {
    de: 'Definieren Sie, was bei der Auswahl der Suchergebnisse angezeigt wird. Verwenden Sie Feature-Eigenschaftsfelder, z. B.',
    en: "Define what's displayed on search result selection: Use feature property fields e.g.",
    fr: 'Définissez ce qui est affiché dans la sélection des résultats de recherche. Utilisez les champs de propriété de fonctionnalité, par ex.',
  },
  searchRegExPattern: {
    de: 'RegEx Muster für Suche',
    en: 'RegEx pattern for search',
    fr: 'Modèle RegEx pour la recherche',
  },
  searchRegExPatternInfo: {
    de: 'Verwenden Sie Regex mit benannten Gruppen, um Sucheingabemuster zu definieren. Der Name muss der Eigenschaftsname sein, in dem gesucht werden soll, z.B.',
    en: 'Use regex with named groups to define search input patterns, the name need to be the property name to search in e.g.',
    fr: "Utilisez l'expression régulière avec des groupes nommés pour définir des modèles d'entrée de recherche, le nom doit être le nom de la propriété dans laquelle rechercher, par exemple",
  },
  searchRegExPatternFullMatch: {
    de: 'Die RegEx werden so angepasst, dass sie nach vollständiger übereinstimmung Suchen',
    en: 'The RegEx will be adjusted to match full search',
    fr: 'Le RegEx sera ajusté pour correspondre à la recherche complète',
  },
  searchRegExPatternOptionsTitle: {
    de: 'Optionen',
    en: 'options',
    fr: 'paramètres',
  },
  searchResultGrouping: {
    de: 'Gruppierung der Ergebnisse',
    en: 'Grouping of results',
    fr: 'Groupement de résultats',
  },
  searchResultGroupingInfo: {
    de: 'Gruppieren der Ergebnisse nach diesen Eigenschaften. Bei zu vielen Ergebnissen wird das erste Ergebnis jeder Gruppe (sortiert nach Beschriftung) angezeigt.',
    en: 'Group results by these properties. If there are too many results, the first result of each group (sorted by label) is displayed.',
    fr: "Regroupez les résultats par ces propriétés. S'il y a trop de résultats, le premier résultat de chaque groupe (trié par étiquette) est affiché.",
  },
  searchMaxResultCount: {
    de: 'Max Anzahl Suchergebnisse',
    en: 'Max number of search results',
    fr: 'Nombre maximum de résultats de recherche',
  },

  //organisationSettings Map Layer
  organisationSettings: {
    de: 'Organisationseinstellungen',
    en: 'Organization settings',
    fr: "Paramètres de l'organisation",
  },
  organisationLayerSettings: {
    de: 'Organisationseinstellungen für Map-Layer',
    en: 'Organizational settings for map layers',
    fr: "Paramètres d'organisation de la couche de carte",
  },
  preSelectedWmsSources: {
    de: 'Vorab ausgewählte WMS-Quellen',
    en: 'Pre-selected WMS sources',
    fr: 'Sources WMS présélectionnées',
  },
  noWmsSourcesAvailable: {
    de: 'Keine WMS-Quellen verfügbar',
    en: 'No WMS sources available',
    fr: 'Aucune source WMS disponible',
  },
  addFromActive: {
    de: 'Von aktiven hinzufügen',
    en: 'Add from active',
    fr: 'Ajouter depuis actif',
  },
  noActiveLayers: {
    de: 'Keine aktiven Ebenen verfügbar',
    en: 'No active layers available',
    fr: 'Aucune couche active disponible',
  },
  addFromList: {
    de: 'Aus Liste hinzufügen',
    en: 'Add from list',
    fr: 'Ajouter à partir de la liste',
  },
  useCurrentSources: {
    de: 'aktuelle Quellen nutzen',
    en: 'use current sources',
    fr: 'utiliser les sources actuelles',
  },
  addAllActiveOnes: {
    de: 'Alle aktiven hinzufügen',
    en: 'Add all active ones',
    fr: 'Ajouter tous les actifs',
  },
  askReplaceExistingLayerSettings: {
    de: 'Ebene {0} existiert bereits. Bestehende Einstellung aktualisieren (OK) oder neue hinzufügen (Abbrechen)?',
    en: 'Layer {0} already exist. Update existing setting (ok) or add new one (cancel)?',
    fr: 'La calque {0} existe déjà. Mettre à jour le paramètre existant (ok) ou en ajouter un nouveau (annuler)?',
  },

  //Blob / offline options
  blobMetaTitle: {
    de: 'Offlineverfügbarkeit des Map-Layers',
    en: 'Offline availability of the map layer',
    fr: 'Disponibilité hors ligne de la couche de carte',
  },
  blobMetaDataTitle: {
    de: 'Karten Daten',
    en: 'Map data',
    fr: 'Données de la carte',
  },
  blobMetaDataDefaultUrl: {
    de: 'Karten Daten URL aus der Konfiguration',
    en: 'Map data URL from config',
    fr: 'URL des données de la carte à partir de la configuration',
  },
  blobMetaDataUrl: {
    de: 'Karten Daten URL lokaler Daten',
    en: 'Map data URL of local data',
    fr: 'URL des données de la carte des données locales',
  },
  blobMetaBlobSource: {
    de: 'lokale Datenquelle:',
    en: 'local data source:',
    fr: 'source de données locale:',
  },
  blobMetaStyleTitle: {
    de: 'Stil',
    en: 'Style',
    fr: 'Style',
  },
  blobMetaStyleLayerSetting: {
    de: '',
    en: 'This layer have text style, pleace adjust in the layer settings (possibly activate expert mode needed)',
    fr: '',
  },
  blobMetaStyleDefaultUrl: {
    de: 'Stil-URL aus der Konfiguration',
    en: 'Style url from config',
    fr: 'URL de style à partir de la configuration',
  },
  blobMetaStyleUrl: {
    de: 'Stil-URL lokaler Daten',
    en: 'Style URL of local data',
    fr: 'URL de style des données locales',
  },
  blobMetaStyleText: {
    de: 'Stil Konfig',
    en: 'style config',
    fr: 'Configuration du style',
  },
  blobMetaNotOfflineLayer: {
    de: 'Diese Ebene kann nicht offline zugänglich gemacht werden.',
    en: 'This layer cannot be made offline accessible.',
    fr: 'Cette Couches cartographiques ne peut pas être rendue accessible hors ligne.',
  },
  blobMetaNotOfflineMap: {
    de: 'Diese Basiskarte kann nicht offline zugänglich gemacht werden.',
    en: 'This base map cannot be made offline accessible.',
    fr: 'Cette carte de base ne peut pas être rendue accessible hors ligne.',
  },

  //filter
  generalFilters: {
    de: 'Globale Filter',
    en: 'Global filters',
    fr: 'Filtre globale',
  },
  showAllElements: {
    de: 'Alle Elemente anzeigen',
    en: 'Show all elements',
    fr: 'Afficher tout',
  },
  hideAllElements: {
    de: 'Alle Elemente verstecken',
    en: 'Hide all elements',
    fr: 'Tout cacher',
  },
  featureClustering: {
    de: 'Symbole Gruppieren',
    en: 'Sign clustering',
    fr: 'Regroupement de formes',
  },
  globalSymbolScale: {
    de: 'Globale Symbolgrösse',
    en: 'Global symbol scale',
    fr: 'Échelle globale des symboles',
  },
  categories: {
    de: 'Kategorien',
    en: 'Categories',
    fr: 'Catégories',
  },
};
